"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _demand = _interopRequireDefault(require("./message/demand"));

var _offer = _interopRequireDefault(require("./message/offer"));

var _result = _interopRequireDefault(require("./message/result"));

var _feedback = _interopRequireDefault(require("./message/feedback"));

var _pending = _interopRequireDefault(require("./message/pending"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function decodeMsg(msg) {
  var json = {};

  try {
    json = JSON.parse(Buffer.from(msg).toString("utf8"));
  } catch (e) {
    throw new Error(e);
  }

  var data = _objectSpread({}, json);

  if (data.signature) {
    data.signature = "0x" + data.signature.replace(/0x/i, "");
  }

  return data;
}

var Messenger = /*#__PURE__*/function () {
  _createClass(Messenger, null, [{
    key: "TYPE_DEMAND",
    get: function get() {
      return "demand";
    }
  }, {
    key: "TYPE_OFFER",
    get: function get() {
      return "offer";
    }
  }, {
    key: "TYPE_RESULT",
    get: function get() {
      return "result";
    }
  }, {
    key: "TYPE_FEEDBACK",
    get: function get() {
      return "feedback";
    }
  }, {
    key: "TYPE_PENDING",
    get: function get() {
      return "pending";
    }
  }]);

  function Messenger(channel) {
    var account = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Messenger);

    this.channel = channel;
    this.account = account;
  }

  _createClass(Messenger, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(message) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.account === null)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Require account");

              case 2:
                if (!(!(message instanceof _demand["default"]) && !(message instanceof _offer["default"]) && !(message instanceof _result["default"]))) {
                  _context.next = 4;
                  break;
                }

                throw new Error("Bad type message");

              case 4:
                _context.next = 6;
                return this.account.signMessage(message);

              case 6:
                message.signature = _context.sent;
                this.channel.send(message.encode());
                return _context.abrupt("return", message);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "on",
    value: function on(callback) {
      function listener(msg) {
        var data = decodeMsg(msg);
        var type;
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function _has(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }

        if (_has(data, "validatorFee")) {
          type = Messenger.TYPE_DEMAND;
        } else if (_has(data, "lighthouseFee")) {
          type = Messenger.TYPE_OFFER;
        } else if (_has(data, "accepted")) {
          type = Messenger.TYPE_FEEDBACK;
        } else if (_has(data, "tx")) {
          type = Messenger.TYPE_PENDING;
        } else if (_has(data, "liability")) {
          type = Messenger.TYPE_RESULT;
        } else {
          callback(new Error("Type not allocated"), null);
          return;
        }

        var message = Messenger.create(type, data);
        callback(null, message);
      }

      this.channel.on(listener);
      return listener;
    }
  }, {
    key: "onDemand",
    value: function onDemand(callback) {
      return this.on(function (error, message) {
        if (!(message instanceof _demand["default"])) {
          return;
        }

        callback(error, message);
      });
    }
  }, {
    key: "onOffer",
    value: function onOffer(callback) {
      return this.on(function (error, message) {
        if (!(message instanceof _offer["default"])) {
          return;
        }

        callback(error, message);
      });
    }
  }, {
    key: "onResult",
    value: function onResult(callback) {
      return this.on(function (error, message) {
        if (!(message instanceof _result["default"])) {
          return;
        }

        callback(error, message);
      });
    }
  }, {
    key: "onFeedback",
    value: function onFeedback(callback) {
      return this.on(function (error, message) {
        if (!(message instanceof _feedback["default"])) {
          return;
        }

        callback(error, message);
      });
    }
  }, {
    key: "onPending",
    value: function onPending(callback) {
      return this.on(function (error, message) {
        if (!(message instanceof _pending["default"])) {
          return;
        }

        callback(error, message);
      });
    }
  }, {
    key: "off",
    value: function off(listener) {
      this.channel.off(listener);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.channel.stop();
    }
  }], [{
    key: "create",
    value: function create(type, data) {
      if (type === this.TYPE_DEMAND) {
        return new _demand["default"](data);
      } else if (type === this.TYPE_OFFER) {
        return new _offer["default"](data);
      } else if (type === this.TYPE_RESULT) {
        return new _result["default"](data);
      } else if (type === this.TYPE_FEEDBACK) {
        return new _feedback["default"](data);
      } else if (type === this.TYPE_PENDING) {
        return new _pending["default"](data);
      }

      throw new Error("Required type message");
    }
  }]);

  return Messenger;
}();

exports["default"] = Messenger;